"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonUtils_1 = require("../../../Helpers/commonUtils");
var ParamValueEnum;
(function (ParamValueEnum) {
    ParamValueEnum[ParamValueEnum["False"] = 0] = "False";
    ParamValueEnum[ParamValueEnum["True"] = 1] = "True";
})(ParamValueEnum || (ParamValueEnum = {}));
const createUrl = (baseUrl, vi, params = {}) => {
    const playerConfigOptions = {
        auto: ParamValueEnum.False,
        tiny: ParamValueEnum.False,
    };
    let url = baseUrl + vi.id;
    url += (0, commonUtils_1.combineParams)({
        params: Object.assign(Object.assign({}, params), playerConfigOptions),
        hasParams: true,
    });
    return url;
};
const parseUrl = (url) => {
    const match = url.match(/(?:cover\/[a-zA-Z0-9]+|page)\/([a-zA-Z0-9]+).html/);
    return match ? match[1] : undefined;
};
const QQ = {
    provider: 'qq',
    defaultFormat: 'long',
    formats: {
        embed: (vi, params) => {
            return QQ.createEmbedUrl(vi, params);
        },
        long: (vi, params) => {
            return QQ.createLongUrl(vi, params);
        },
        static: (vi, params) => {
            return QQ.createStaticUrl(vi, params);
        },
    },
    mediaTypes: {
        VIDEO: 'video',
    },
    parse: (url, params) => {
        const id = parseUrl(url);
        if (!id) {
            return undefined;
        }
        return {
            params,
            mediaType: QQ.mediaTypes.VIDEO,
            id,
        };
    },
    createEmbedUrl: (vi, params) => {
        return createUrl('//v.qq.com/txp/iframe/player.html?vid=', vi, params);
    },
    createLongUrl: (vi, params) => {
        return createUrl('//v.qq.com/txp/iframe/player.html?vid=', vi, params);
    },
    createStaticUrl: (vi, params) => {
        return createUrl('//static.video.qq.com/TPout.swf?vid=', vi, params);
    },
};
exports.default = QQ;
